"use client";

import { useState, useEffect } from "react";
import { useTranslations } from "next-intl";
import { FaChevronUp } from "react-icons/fa";

export default function ScrollToTop() {
	const t = useTranslations("Common");
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		const onScroll = () =>
			setVisible(typeof window !== "undefined" && window.scrollY > 300);
		onScroll();
		window.addEventListener("scroll", onScroll);
		return () => window.removeEventListener("scroll", onScroll);
	}, []);

	const goToTop = () => {
		if (typeof window === "undefined") return;
		window.scrollTo({ top: 0, behavior: "smooth" });
	};

	return (
		<button
			type="button"
			onClick={goToTop}
			aria-label={t("scrollToTop")}
			className={`fixed bottom-0 left-0 z-[10000] flex h-12 w-12 items-center justify-center rounded-full bg-[#0d6efd] text-white shadow-lg transition-opacity duration-200 m-4 mb-5 ml-4 ${
				visible ? "opacity-100" : "pointer-events-none opacity-0"
			}`}
		>
			<FaChevronUp className="h-6 w-6" aria-hidden />
		</button>
	);
}
